.enabloLogo {
  height: 1.5rem;
}
